export default "__VITE_ASSET__CW34Ja9s__"